export default defineNuxtPlugin( async (nuxtApp) => {
  const config = useRuntimeConfig()

  const  { session, refresh} = await useSession()

  // const token = nuxtApp.ssrContext?.event?.context?.session?.token;
  
  
  
    const apiAuthToken = $fetch.create({
      baseURL: config.public.API_BASE_URL,
    async onRequest({ request, options, error }) {
   
      await refresh()
  
      if (session.value?.token) {
        const headers = options.headers ||= {}
        if (Array.isArray(headers)) {
          headers.push(['Authorization', `Bearer ${session.value?.token}`])
        } else if (headers instanceof Headers) {
          headers.set('Authorization', `Bearer ${session.value?.token}`)
        } else {
          headers.Authorization = `Bearer ${session.value?.token}`
        }
      }
    },
    async onResponseError({ response }) {

      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo('/login-admin'))
      }
    }
  })
    // Expose to useNuxtApp().$api
    return {
      provide: {
        apiAuthToken
      }
    }
  })
  
